import { CompedTickets as CompedTicketsComponent } from 'features/CompedTickets';
import { PunchupCompedTickets } from 'features/PunchupPages/CompedTickets';
import { PunchupCompedTickets as LegacyPunchupCompedTickets } from 'features/PunchupCompedTickets';
import { useAppSelector } from 'store/hooks';

const CompedTicketsPage = (): JSX.Element => {
	const { isPunchup, greenZoneEnabled } = useAppSelector((state) => state.auth);

	if (isPunchup && greenZoneEnabled) return <PunchupCompedTickets />;
	if (isPunchup) return <LegacyPunchupCompedTickets />;
	return <CompedTicketsComponent />;
};
export default CompedTicketsPage;
